import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-viewer-afilead',
  templateUrl: './report-viewer-afilead.component.html',
  styleUrls: ['./report-viewer-afilead.component.sass']
})
export class ReportViewerAfileadComponent implements OnInit {

  @Input()
  public selectedReport: any;

  constructor() { }

  ngOnInit(): void {
  }

}
